"use client";

import React from "react";
import { Activity, Cpu, Network, Server, Zap, ArrowRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const bentoItems = [{
  id: 1,
  title: "Hyperscale GPU Clusters",
  description: "Next-generation compute facilities optimized for LLM training and high-throughput inference workloads.",
  span: "md:col-span-8",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/gpu_cluster_high_speed.png",
  metricLabel: "Compute Capacity",
  metricValue: "100+ ExaFLOPS",
  icon: Cpu,
  hasImage: true
}, {
  id: 2,
  title: "Power Usage Effectiveness",
  description: "Industry-leading sustainable energy utilization across all managed facilities.",
  span: "md:col-span-4",
  metricLabel: "Target PUE",
  metricValue: "1.12",
  progress: 88,
  icon: Zap,
  hasImage: false
}, {
  id: 3,
  title: "Ultra-Low Latency Fabric",
  description: "Optical interconnects minimizing data transfer bottlenecks for distributed training.",
  span: "md:col-span-4",
  metricLabel: "Bandwidth",
  metricValue: "3.2 Tbps",
  icon: Network,
  hasImage: false
}, {
  id: 4,
  title: "Strategic Capital Deployment",
  description: "Accelerating the development of critical AI infrastructure globally through targeted investments.",
  span: "md:col-span-8",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/data_center_global_network.png",
  metricLabel: "Active Nodes",
  metricValue: "42 Global Locations",
  icon: Server,
  hasImage: true
}];
export default function NeuralInfrastructure() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}